import React, {useState, useEffect} from "react";
import { Grid, Box, Breadcrumbs, Link, Typography, TextField, Button } from "@mui/material";
import FormDialog from "components/modal";
import { Divider } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { baseURL, imageURL } from "services/API";
import axios from "axios";
import { Document, Page } from "react-pdf";
import { FlexColCenter } from "components/FlexBox/FlexBox";
import * as yup from 'yup';
import DocumentUploadPill from "components/DocumentUploadPill";
import { setupPdfWorker } from "utils/setupPdfWorker";

setupPdfWorker();

export default function OnboardingConfirmation() {
  const navigate = useNavigate();
  const [openDocument, setOpenDocument] = useState(false);
  const [openBackID, setOpenBackID] = useState(false);
  const [openFrontID, setOpenFrontID] = useState(false);
	const [businessTerms, setBusinessTerms] = useState({});
  const [userComment, setUserComment] = useState("");
  const [errors, setErrors] = useState({});
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [refreshCount, setRefreshCount] = useState(0)

  const commentSchema = yup.object().shape({
    userComment: yup.string().required('Please provide a reason for rejecting the document')
  })

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const token = useSelector((state) => state.token);
  const landlord = useSelector((state) => state.landlord); 
  
  useEffect(() => {
    const checkDetails = async () => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const response = await axios.get(`${baseURL}/landlords/details/${landlord.id}`);
      setBusinessTerms(response.data.business_terms);
    };
    checkDetails();
  }, [refreshCount]);

  const handleChangeComment = (e)=>{
    const {value} = e.target;
    if (!toString(value).trim()) {
      		setErrors((prev) => ({ ...prev, 'userComment': `This field is required`}));
		} else {
			setErrors((prev) => ({ ...prev, "userComment": "" }));
		}
    setUserComment(value);
  }

  const handleClickOpenDocument = () => {
		setOpenDocument(true);
	};

	const handleCloseDocument = () => {
    setErrors({});
    setUserComment("");
		setOpenDocument(false);
	};

  const handleClickOpenBackID = () => {
		setOpenBackID(true);
	};

  const handleClickOpenFrontID = () => {
		setOpenFrontID(true);
	};

	const handleCloseID = () => {
    setErrors({});
    setUserComment("")
    setOpenBackID(false);
		setOpenFrontID(false);
	};

  const handleSubmitOverallApproval =  () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.post(`${baseURL}/admin/landlords/mark_complete/approve`, {landlord_id: landlord.id, status: 2, commment: userComment})
    .then(
      (response)=> { 
        return response.data
      }
    ).then(
      data => {
        setRefreshCount(prev => prev + 1);
        navigate("/landlords")
      }
    ).catch();
  };

  const handleSubmitDocumentApproval =  () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.post(`${baseURL}/admin/landlords/business_terms/approve`, {landlord_id: landlord.id, status: 2, commment: userComment})
    .then(
      (response)=> { 
        return response.data
      }
    ).then(
      data => {
        setRefreshCount(prev => prev + 1);
        handleCloseDocument()
      }
    ).catch();
  };

  const handleSubmitDocumentReject = async () => {
    console.log('here')
    try {
      await commentSchema.validate({userComment: userComment}, {abortEarly: false})
    } catch (error) {
      const newError = {}
      error.inner.forEach(err => {
        newError[err.path]=err.message
      })
      setErrors(newError)
      return
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.post(`${baseURL}/admin/landlords/business_terms/approve`, {landlord_id: landlord.id, status: 3, commment: userComment})
    .then(
      (response)=> { 
        return response.data
      }
    ).then(
      data => {
        setRefreshCount((prev) => prev + 1);
        handleCloseDocument()
      }
    ).catch();
  };

  const handleSubmitImageApproval =  (position) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.post(`${baseURL}/admin/landlords/${position}/approve`, {landlord_id: landlord.id, status: 2, commment: userComment})
    .then(
      (response)=> { 
        return response.data
      }
    ).then(
      data => {
        setRefreshCount(prev => prev + 1);
        handleCloseID()
      }
    ).catch(); 
  };

  const handleSubmitImageReject = async (position) => {
    try {
      await commentSchema.validate({userComment: userComment}, { abortEarly: false });
    } catch (error) {
      console.log(error);
      const newError = {};
      error.inner.forEach((err) => {
        newError[err.path] = err.message;
      });
      setErrors(newError);
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.post(`${baseURL}/admin/landlords/${position}/approve`, {landlord_id: landlord.id, status: 3, commment: userComment})
    .then(
      (response)=> { 
        return response.data
      }
    ).then(
      data => {
        setRefreshCount(prev => prev + 1);
        handleCloseID()
      }
    ).catch();
  };


	return (
    <Box m="20px">
      <Breadcrumbs>
        <Link underline="hover" sx={{ display: "flex", alignItems: "center", margin:"10px 0" }} color="inherit" onClick={() => navigate("/landlords")}>
          <BusinessIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          <Typography variant="h6">Landlord</Typography>
        </Link>
        <Typography sx={{ display: "flex", alignItems: "center" }} color="text.primary">
          <b>Onboarding Landlord Documents</b>
        </Typography>
      </Breadcrumbs>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h1>{landlord.related_user.first_name} {landlord.related_user.last_name} Landlord Documents</h1>
          <h3>RENT COLLECTION SERVICE AGREEMENT</h3>
          <Box sx={{ border: "1px solid black", padding: "10px" }}>
            <DocumentUploadPill 
              pillTitle={"TERMS OF BUSINESS"} pillDescription={   "Review the Signed working terms of business document"} 
              buttonText={[1,3].includes(businessTerms.business_terms_status) ? "Review Document" : businessTerms.business_terms_status===2 ? "View Approved Document" : null } buttonAction={handleClickOpenDocument} 
              imageView={true} showLink={false} 
              imageColour={businessTerms.business_terms_status===2 ? 'green' : businessTerms.business_terms_status=== 3 ? 'red' : "#ff5722"}
              imageDescription={businessTerms.business_terms_status===5 ? 'Document has not yet been Uploaded.......' : businessTerms.business_terms_status===2 ? 'ID has been Verifed'  : businessTerms.business_terms_status=== 3 ? 'Rejected pending reupload' : businessTerms.business_terms_status=== 1 ? 'ID has been Uploaded': null }
            />
            <Divider />
          </Box>

          <h3>NATIONAL IDENTITY CARD</h3>
          <Box sx={{ border: "1px solid black", padding: "10px" }}>
            <DocumentUploadPill 
              pillTitle={"Front of ID"} pillDescription={   "Review the a photo of the FRONT part of your National ID" }
              buttonText={[1,3].includes(businessTerms.id_front_status) ? "Review ID" : businessTerms.id_front_status===2 ? "View Approved ID" : null } buttonAction={handleClickOpenFrontID}
              imageView={true} showLink={false} 
              imageColour={businessTerms.id_front_status===2 ? 'green' : businessTerms.id_front_status=== 3 ? 'red' : "#ff5722"}
              imageDescription={businessTerms.id_front_status===0 ? 'Document has not yet been Uploaded.......' : businessTerms.id_front_status===2 ? 'ID has been Verifed'  : businessTerms.id_front_status=== 3 ? 'Rejected pending reupload' : businessTerms.id_front_status=== 1 ? 'ID has been Uploaded': null }
            />
            <Divider />
            <DocumentUploadPill 
              pillTitle={"Back of ID"} pillDescription={   "Review the a photo of the FRONT part of your National ID" } 
              buttonText={[1,3].includes(businessTerms.id_back_status) ? "Review ID" : businessTerms.id_back_status===2 ? "View Approved ID" : null } buttonAction={handleClickOpenBackID} 
              imageView={true} showLink={false} 
              imageColour={businessTerms.id_back_status===2 ? 'green' : businessTerms.id_back_status=== 3 ? 'red' : "#ff5722"}
              imageDescription={businessTerms.id_back_status===0 ? 'Document has not yet been Uploaded.......' : businessTerms.id_back_status===2 ? 'ID has been Verifed'  : businessTerms.id_back_status=== 3 ? 'Rejected pending reupload' : businessTerms.id_back_status=== 1 ? 'ID has been Uploaded': null }
            />
            <Divider />
          </Box>
          {businessTerms.business_terms_status===2 && businessTerms.id_back_status===2 && businessTerms.id_front_status===2 && <Button onClick={handleSubmitOverallApproval} sx={{ marginY: "20px", backgroundColor: "green", padding:"10px", width:"200px", color:"white"}}>Save Approval</Button>}
        </Grid>
      </Grid>
      <FormDialog
        open={openDocument}
        handleClose={handleCloseDocument}
        title={"Rent Collection Agreement"}
        handleSubmit={handleSubmitDocumentApproval}
        buttonText="Approve"
        handleSubmit2={handleSubmitDocumentReject}
        buttonText2="Reject"
        enableActions={[1].includes(businessTerms.business_terms_status) ? true : false }
        buttonClass={"add-button"}
        width="md"
        content={
          <FlexColCenter>
            <p>Alternative  link <a href={imageURL+businessTerms.business_terms_document} target="_blank" rel="noreferrer">to download the PDF!</a></p>
            <Document file={imageURL+businessTerms.business_terms_document} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={pageNumber} width={800}/>
            </Document>
            {[1].includes(businessTerms.business_terms_status) && <TextField fullWidth name="userComment" value={userComment} onChange={handleChangeComment} multiline rows={2} label="Comment" error={Boolean(errors.userComment)} helperText={errors.userComment} sx={{ marginY: "15px" }}/>}
          </FlexColCenter>
        }
      />

      <FormDialog
        open={openFrontID}
        handleClose={handleCloseID}
        title={"Front ID Image"}
        handleSubmit={()=>handleSubmitImageApproval('id_front')}
        buttonText="Approve"
        handleSubmit2={()=>handleSubmitImageReject('id_front')}
        buttonText2="Reject"
        enableActions={[1].includes(businessTerms.id_front_status) ? true : false }
        buttonClass={"delete-button"}
        width="md"
        content={
          <FlexColCenter>
            <p>Alternative  link <a href={imageURL+businessTerms.id_front_document} target="_blank" rel="noreferrer">to the Image!</a></p>
            <object data={imageURL+businessTerms.id_front_document} width="100%" height="100%"></object>
            {[1].includes(businessTerms.id_front_status) && <TextField fullWidth name="userComment" value={userComment} onChange={handleChangeComment} multiline rows={2} label="Comment" error={Boolean(errors.userComment)} helperText={errors.userComment} sx={{ marginY: "15px" }}/>}
          </FlexColCenter>
        }
      />

      <FormDialog
        open={openBackID}
        handleClose={handleCloseID}
        title={"Back ID Image"}
        handleSubmit={()=>handleSubmitImageApproval('id_back')}
        buttonText="Approve"
        handleSubmit2={()=>handleSubmitImageReject('id_back')}
        buttonText2="Reject"
        enableActions={[1].includes(businessTerms.id_back_status) ? true : false }
        buttonClass={"delete-button"}
        width="md"
        content={
          <FlexColCenter>
            <p>Alternative  link <a href={imageURL+businessTerms.id_back_document} target="_blank" rel="noreferrer">to the Image!</a></p>
            <object data={imageURL+businessTerms.id_back_document} width="100%" height="100%"></object>
            {[1].includes(businessTerms.id_back_status) && <TextField fullWidth name="userComment" value={userComment} onChange={handleChangeComment} multiline rows={2} label="Comment" error={Boolean(errors.userComment)} helperText={errors.userComment} sx={{ marginY: "15px" }}/>}
          </FlexColCenter>
        }
      />
    </Box>
  );
}
